module.exports = __webpack_public_path__ + "static/img/green.c4c3728e.png";